<template>
  <a-date-picker @change="valueChange" :allowClear="allowClear" v-model="dateValue" v-bind="$attrs" v-on="$listeners"></a-date-picker>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ptDatePicker',
    props:{
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [String, Array] ,
      },
      formatStr:{
        type:String,
        default:"YYYY-MM-DD"
      }
    },
    data() {
      return {
        dateValue:undefined
      }
    },
    mounted(){
      let val = this.value
      console.log(val)
      if(val == '~'){
        this.dateValue = undefined
      }else{
        if(typeof(val)=='string'){
          this.dateValue = moment(val,this.formatStr)
        }else{
          this.dateValue = val
        }
      }
    },
    watch:{
      value (val) {
        console.log(val)
        if(val == '~'){
          this.dateValue = undefined
        }else{
          if(typeof(val)=='string'){
            this.dateValue = moment(val,this.formatStr)
          }else{
            this.dateValue = val
          }
        }
      },
      dateValue(val){
        let value = moment(val).format(this.formatStr)
        this.$emit('input',value)
      }
    },
    methods:{
      valueChange(val){
        let value = moment(val).format('YYYY-MM-DD')
        this.$emit('change',value)
      }
    }
  }
</script>

<style scoped lang="less">

</style>
